import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div className="space-y-4">
            <div className="text-xl font-light text-gray-900" style={{ fontFamily: '"Pacifico", serif' }}>
              Healing Paw Vet
            </div>
            <p className="text-sm text-gray-600 leading-relaxed">
              수의사가 만든<br />
              반려동물 홉 CBD 브랜드
            </p>
          </div>
          <div>
            <h3 className="text-sm font-medium text-gray-900 mb-4">제품 정보</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  홉 CBD란
                </Link>
              </li>
              <li>
                <Link to="/cases" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  반려동물 케이스
                </Link>
              </li>
              <li>
                <Link to="/science" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  연구 & 안전성
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-medium text-gray-900 mb-4">고객 지원</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/faq" className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer">
                  FAQ
                </Link>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('contact-form')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer"
                >
                  문의하기
                </button>
              </li>
              <li>
                <button 
                  onClick={() => document.getElementById('waitlist-form')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer"
                >
                  출시 알림 신청
                </button>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-medium text-gray-900 mb-4">연락처</h3>
            <ul className="space-y-3">
              <li className="text-sm text-gray-600">
                이메일: info@kriyahops.com
              </li>
              <li className="text-sm text-gray-600">
                전화: 02-1234-5678
              </li>
            </ul>
          </div>
        </div>
        <div className="pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-sm text-gray-600">
            © 2024 Healing Paw Vet. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-sm text-gray-600 hover:text-gray-900 transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
